(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mnr-collection-v2"] && !Shopify.designMode) return;
  try {
    
  /* Eén javascript-blok per sectie: Shopify weigert een tweede. */

  /* ── Diepe link naar een kaart ── */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Bundelmodus. De ladderrekenkunde komt uit assets/mnr-bundle-ladder.js,
     hetzelfde bestand dat nail-bundle-selector-v3 gebruikt — één ladder, één
     implementatie. De payload heeft dezelfde vorm als op de productpagina:
     losse varianten met _bundle-property, of één Starter Set variant met de
     designs als Design N properties.

     Gedelegeerd vanaf document, want de Section Rendering API vervangt de
     sectie-HTML bij elk filter en listeners op vervangen markup overleven dat
     niet. De selectie zelf leeft in een Map buiten de DOM en overleeft dus
     een filterwissel. */
  (() => {
    if (window.__mnrcBundle) return;
    window.__mnrcBundle = true;

    /* Geordende lijst MET herhalingen, precies zoals nail-bundle-selector-v3.
       Een Map kon hetzelfde design maar één keer bevatten, waardoor een
       tweede klik het juist weghaalde — op de PDP kon het wel. */
    const picked = [];                       // [variantId, variantId, …]
    const meta = new Map();                  // variantId -> { name, thumb }
    const countOf = (id) => picked.reduce((n, x) => (x === id ? n + 1 : n), 0);
    let lamp = null;          // null | 'have' | 'need' — bewust geen default
    let busy = false;

    const rootOf = (el) => el && el.closest('[data-mnrc-bundle-config]');
    const cfgOf = (root) => {
      if (!root.__cfg) {
        try { root.__cfg = JSON.parse(root.dataset.mnrcBundleConfig); }
        catch (e) { root.__cfg = null; }
      }
      return root.__cfg;
    };
    const q = (root, k) => root.querySelector(`[data-mnrc="${k}"]`);

    function syncPicks(root) {
      const cfg = cfgOf(root);
      root.querySelectorAll('.mnrc__card').forEach((card) => {
        const btn = card.querySelector('[data-mnrc="bundle-pick"]');
        if (!btn) return;
        const id = card.dataset.mnrcVariant;
        const q = countOf(id);
        btn.setAttribute('aria-pressed', String(q > 0));
        const n = btn.querySelector('.pick-n');
        if (n) n.textContent = q > 1 ? ' ' + q : '';
        const minus = card.querySelector('[data-mnrc="bundle-unpick"]');
        if (minus) minus.hidden = q === 0;
        const max = card.dataset.mnrcMax === '' ? Infinity : parseInt(card.dataset.mnrcMax, 10) || 0;
        const room = cfg && picked.length < cfg.maxQty && q < max;
        btn.setAttribute('aria-label', q === 0
          ? 'Voeg ' + card.dataset.mnrcName + ' toe aan je bundel'
          : card.dataset.mnrcName + ', ' + q + ' gekozen' + (room ? ', voeg er nog één toe' : ''));
      });
    }

    function render(root) {
      const L = window.MNRBundleLadder;
      const cfg = cfgOf(root);
      if (!L || !cfg) return;

      const n = picked.length;
      const bar = q(root, 'bundlebar');
      bar.hidden = root.dataset.bundle !== '1' || n === 0;
      if (bar.hidden) return;

      const starter = L.starterFor(n, cfg);
      const useSet = lamp === 'need' && starter;
      const total = useSet ? starter.price : L.priceFor(n, cfg);
      const save = L.savingsFor(n, cfg, useSet ? starter.price : undefined);

      /* Miniaturen in keuzevolgorde, herhalingen inbegrepen. */
      const thumbs = q(root, 'bb-thumbs');
      if (thumbs) {
        thumbs.innerHTML = '';
        picked.forEach((id, i) => {
          const m = meta.get(id) || {};
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'mnrc__bundlethumb';
          b.dataset.mnrc = 'bb-thumb';
          b.dataset.variant = id;
          b.setAttribute('aria-label', 'Verwijder ' + (m.name || 'design') + ' uit je bundel');
          if (m.thumb) {
            const img = document.createElement('img');
            img.src = m.thumb;
            img.alt = '';
            img.loading = 'lazy';
            img.width = 40;
            img.height = 40;
            b.appendChild(img);
          }
          thumbs.appendChild(b);
        });
      }

      q(root, 'bb-price').textContent = L.money(total, cfg);
      q(root, 'bb-count').textContent = `${n} van ${cfg.maxQty} gekozen`;

      const next = L.nextTier(n, cfg);
      q(root, 'bb-next').textContent = next
        ? `Nog ${next.qty - n} erbij: ${L.money(next.price, cfg)} · je voordeel ${L.money(L.savingsFor(next.qty, cfg), cfg)}`
        : `Beste prijs bereikt · je voordeel ${L.money(save, cfg)}`;

      /* Prijzen in de lampkeuze lopen mee met het aantal. */
      const lampBox = q(root, 'bb-lamp');
      if (!lampBox.hidden) {
        q(root, 'bb-have-price').textContent = L.money(L.priceFor(n, cfg), cfg);
        if (starter) {
          q(root, 'bb-need-price').textContent = L.money(starter.price, cfg);
          const gap = starter.qty - n;
          /* Geen 'Starter Set ' ervoor plakken: de varianttitel bevat die
             woorden al, wat "Starter Set Sticker Starter Set Essentials"
             opleverde. De merchant bepaalt de titel, wij tonen hem. */
          q(root, 'bb-need-text').textContent = gap > 0
            ? `${starter.label} — dekt ${starter.qty}, je koos er ${n}`
            : starter.label;
        } else {
          /* Geen set die dit aantal dekt (een settariant is uitverkocht).
             starterFor rondt bewust niet naar beneden af, dus hier is de
             optie gewoon niet beschikbaar. */
          q(root, 'bb-need-price').textContent = '';
          q(root, 'bb-need-text').textContent = `Tijdelijk niet leverbaar bij ${n} design${n > 1 ? 's' : ''}`;
        }
        const needOpt = lampBox.querySelector('.mnrc__lopt[data-lamp="need"]');
        if (needOpt) {
          needOpt.disabled = !starter;
          needOpt.setAttribute('aria-disabled', String(!starter));
        }
        lampBox.querySelectorAll('.mnrc__lopt').forEach((o) => {
          o.setAttribute('aria-checked', String(o.dataset.lamp === lamp));
        });
      }
    }

    function setMode(root, on) {
      root.dataset.bundle = on ? '1' : '0';
      const s = q(root, 'mode-single');
      const b = q(root, 'mode-bundle');
      if (s) s.setAttribute('aria-pressed', String(!on));
      if (b) b.setAttribute('aria-pressed', String(on));
      if (!on) { q(root, 'bb-lamp').hidden = true; lamp = null; }
      render(root);
    }

    document.addEventListener('click', async (e) => {
      const root = rootOf(e.target);
      if (!root) return;
      const cfg = cfgOf(root);
      const L = window.MNRBundleLadder;

      if (e.target.closest('[data-mnrc="mode-single"]')) return setMode(root, false);
      if (e.target.closest('[data-mnrc="mode-bundle"]')) return setMode(root, true);

      const pick = e.target.closest('[data-mnrc="bundle-pick"]');
      if (pick) {
        const card = pick.closest('.mnrc__card');
        const id = card.dataset.mnrcVariant;
        const max = card.dataset.mnrcMax === '' ? Infinity : parseInt(card.dataset.mnrcMax, 10) || 0;
        if (picked.length >= cfg.maxQty || countOf(id) >= max) return;
        meta.set(id, { name: card.dataset.mnrcName, thumb: card.dataset.mnrcThumb });
        picked.push(id);
        syncPicks(root);
        return render(root);
      }

      const unpick = e.target.closest('[data-mnrc="bundle-unpick"]');
      if (unpick) {
        const id = unpick.closest('.mnrc__card').dataset.mnrcVariant;
        const i = picked.lastIndexOf(id);
        if (i >= 0) picked.splice(i, 1);
        syncPicks(root);
        return render(root);
      }

      /* Miniatuur in de balk: klikken haalt dat exemplaar eruit. */
      const thumb = e.target.closest('[data-mnrc="bb-thumb"]');
      if (thumb) {
        const i = picked.lastIndexOf(thumb.dataset.variant);
        if (i >= 0) picked.splice(i, 1);
        syncPicks(root);
        return render(root);
      }

      const lopt = e.target.closest('.mnrc__lopt');
      if (lopt) { lamp = lopt.dataset.lamp; return render(root); }

      const submit = e.target.closest('[data-mnrc="bb-submit"]');
      if (!submit || busy) return;

      /* Eerste klik onthult de lampvraag; pas met een keuze wordt toegevoegd. */
      const lampBox = q(root, 'bb-lamp');
      const hasStarter = cfg.starterTiers && cfg.starterTiers.length > 0;
      if (hasStarter && lampBox.hidden) {
        lampBox.hidden = false;
        render(root);
        const first = lampBox.querySelector('.mnrc__lopt');
        if (first) first.focus();
        return;
      }
      if (hasStarter && !lamp) {
        const first = lampBox.querySelector('.mnrc__lopt');
        if (first) first.focus();
        return;
      }

      const err = q(root, 'bb-error');
      err.hidden = true;
      busy = true;
      submit.dataset.loading = '1';
      submit.disabled = true;

      const n = picked.length;
      let items;
      if (lamp === 'need' && hasStarter) {
        const st = L.starterFor(n, cfg);
        if (!st) {
          /* Dekt geen enkele beschikbare set dit aantal, dan is er niets te
             versturen. Nooit terugvallen op losse designregels: die leveren
             geen lamp aan iemand die net zei er geen te hebben. */
          err.textContent = `Er is geen Starter Set die ${n} designs dekt. Kies er minder, of bestel de lamp los.`;
          err.hidden = false;
          busy = false;
          submit.dataset.loading = '0';
          submit.disabled = false;
          return;
        }
        const props = { _bundle: `nbs-starter-${st.qty}` };
        picked.forEach((id, i) => { props[`Design ${i + 1}`] = meta.get(id).name; });
        items = [{ id: st.variantId, quantity: 1, properties: props }];
      } else {
        /* Twee keer hetzelfde design wordt één regel met quantity 2 — Shopify
           voegt gelijke variant+property combinaties toch samen. */
        const grouped = new Map();
        picked.forEach((id) => grouped.set(id, (grouped.get(id) || 0) + 1));
        items = [...grouped].map(([id, qty]) => ({
          id: parseInt(id, 10),
          quantity: qty,
          properties: { _bundle: `nbs-${n}` },
        }));
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Toevoegen is niet gelukt.');
        }
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null)).catch(() => null);
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'mnrc-bundle',
            data: { source: 'mnr-collection-v2', itemCount: cart ? cart.item_count : items.length },
          },
        }));
        picked.length = 0;
        meta.clear();
        lamp = null;
        lampBox.hidden = true;
        syncPicks(root);
        render(root);
      } catch (ex) {
        err.textContent = ex.message;
        err.hidden = false;
      } finally {
        busy = false;
        submit.dataset.loading = '0';
        submit.disabled = false;
      }
    });

    /* Na een filterwissel is de markup vervangen: selectie opnieuw aanzetten.

       De observer reageert ALLEEN op toegevoegde productkaarten. Een brede
       observer die op elke mutatie synchroniseert loopt vast: render() zet
       textContent op de balk, dat is zelf een childList-mutatie, en dan roept
       de observer zichzelf eindeloos aan tot de pagina bevriest. render()
       voegt nooit een kaart toe, dus deze filter breekt die lus. */
    new MutationObserver((records) => {
      const cardsAdded = records.some((rec) =>
        [...rec.addedNodes].some(
          (n) =>
            n.nodeType === 1 &&
            (n.matches?.('.mnrc__card, .product-grid__item') || n.querySelector?.('.mnrc__card'))
        )
      );
      if (!cardsAdded) return;
      document.querySelectorAll('[data-mnrc-bundle-config]').forEach((root) => {
        syncPicks(root);
        render(root);
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ── Filtertabs openen bij hover ──
     Alleen op desktop met een echte muis. Horizons <details> blijft de
     bron van waarheid: we zetten alleen .open, dus Escape, klikken buiten
     het paneel (auto-close-details) en de toetsenbordroute werken als
     voorheen. Gedelegeerd vanaf document omdat de Section Rendering API
     de balk bij elk filter vervangt. */
  (() => {
    if (window.__mnrcHoverFacets) return;
    window.__mnrcHoverFacets = true;

    const hoverable = window.matchMedia('(hover: hover) and (min-width: 750px)');
    const ITEM = '.mnrc .facets--horizontal :is(.facets__item, .sorting-filter)';
    const timers = new WeakMap();

    const schedule = (item, open, delay) => {
      clearTimeout(timers.get(item));
      timers.set(
        item,
        setTimeout(() => {
          const details = item.querySelector('details.facets__panel');
          if (!details || details.open === open) return;
          if (open) {
            document.querySelectorAll(`${ITEM} details[open]`).forEach((other) => {
              if (other !== details) other.removeAttribute('open');
            });
            details.dataset.mnrcHover = '1';
            details.open = true;
          } else {
            delete details.dataset.mnrcHover;
            details.open = false;
          }
        }, delay)
      );
    };

    document.addEventListener('mouseover', (e) => {
      if (!hoverable.matches) return;
      const item = e.target.closest?.(ITEM);
      if (!item || item.contains(e.relatedTarget)) return;
      schedule(item, true, 60);
    });

    document.addEventListener('mouseout', (e) => {
      if (!hoverable.matches) return;
      const item = e.target.closest?.(ITEM);
      if (!item || (e.relatedTarget && item.contains(e.relatedTarget))) return;
      schedule(item, false, 180);
    });

    /* Een klik op een tab die door hover al open staat mag hem niet
       dichtklappen; dat voelt als een kapotte knop. */
    document.addEventListener(
      'click',
      (e) => {
        if (!hoverable.matches) return;
        const summary = e.target.closest?.(`${ITEM} summary`);
        const details = summary?.closest('details');
        if (details?.open && details.dataset.mnrcHover) e.preventDefault();
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
